import { attachListener, getCookie, setCookie } from "./utilities";

export default function main() {
    attachListener('.LUISAlert__closeBtn', 'click', closeAlert);
    hideAlerts();
}

function closeAlert(event) {
    const alertId = event.target.getAttribute('data-controls');
    const alert = document.getElementById(alertId);
    alert.remove();
    const expiration = alert.getAttribute('data-cookie-expiration');
    setCookie('LUISAlerts-' + alertId, 1, expiration);
}

function hideAlerts() {
    const alerts = document.querySelectorAll('.LUISAlert');
    for(let alert of alerts) {
        let cookie = getCookie('LUISAlerts-' + alert.id); 
        if(cookie) {
            alert.remove();
        }
    }
}